import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
});

export const adminClient = axios.create({
  baseURL: API,
});

adminClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("sandlab_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const athleteClient = axios.create({
  baseURL: API,
});

athleteClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("sandlab_athlete_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
